import { component } from 'picoapp';
import { clear } from 'utils/node';

export default component(async (node) => {
  const upsellList = node.querySelector('[data-upsell-items]');
  let showUpsellList = false;

  const initializeUpsellFeed = () => {
    showUpsellList = false;
    const upsellProducts: NodeListOf<HTMLElement> = node.querySelectorAll('[data-variant]');
    upsellProducts.forEach((product) => {
      const submitButton: HTMLButtonElement = product.querySelector('[data-submit]');

      if (submitButton) {
        submitButton.addEventListener('click', () => {
          const data = JSON.parse(product.dataset.variant);
          const item = {
            id: data.id,
            quantity: 1,
            compare_at_price: data.compare_at_price,
            tags: data.tags,
          };
          submitButton.disabled = true;
          submitButton.innerHTML = theme.strings.upsellAdded;
          document.dispatchEvent(new CustomEvent('cart:add:variant', { detail: { items: [item] } }));
        });
      }

      if (product.getAttribute('data-in-cart') === 'false') {
        showUpsellList = true;
      }
    });
  };

  initializeUpsellFeed();

  document.addEventListener('cart:opened', () => {
    if (showUpsellList) {
      node.setAttribute('data-active', 'true');
    }
  });

  document.addEventListener('cart:close', () => {
    node.setAttribute('data-active', 'false');
  });

  document.addEventListener('cart:updated', async () => {
    const fetchUpsellProductFeed = await fetch('/cart?view=upsell')
      .then((response) => response.text());

    clear(upsellList);
    upsellList.insertAdjacentHTML('beforeend', fetchUpsellProductFeed);
    initializeUpsellFeed();

    node.setAttribute('data-active', `${showUpsellList}`);
  });
});
